import { CreateCannyTokenDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createCannyTokenCallable = getCallable(CreateCannyTokenDefinition);
